firebird.factory('notificationService', [
    '$rootScope',
    '$window',
    '$timeout',
    'analyticsWrapperService',
    'desktopNotificationService',
    'growlService',
    'helperService',
    'logService',
    'meetingService',
    'localizationService',
    'brandingService',
    function (
        $rootScope,
        $window,
        $timeout,
        analyticsWrapperService,
        desktopNotificationService,
        growlService,
        helperService,
        logService,
        meetingService,
        localizationService,
        brandingService
    ) {
        const logger = logService.createLoggerWithSource('notificationService');

        var service = {
            canShowDesktopNotification: canShowDesktopNotification,
            show: show,
            overrideSwal: overrideSwal,
            //This only effects chat notifications for the host from attendees and was specifically made for webinar
            determineStateOfChatNotifications: determineStateOfChatNotifications,
            //This affects all desktop notifications and was specifically made for meetings
            determineIfShowingDesktopNotifications: determineIfShowingDesktopNotifications,
            tryShowDesktopNotification: tryShowDesktopNotification
        };

        //when false chat desktop notifications are able to be received
        let disabledChatNotifications = false;
        let userShowingDesktopNotifications = true;
        let swalIsOpen = false;
        let inCompactMode = false;
        const swalQueue = [];

        $rootScope.$on('notification-service-show', onNotificationServiceShow);
        $rootScope.$on('server-command-failed', onServerCommandFailed);
        $rootScope.$on('enable-compact-mode', onCompactModeReceived);

        return service;

        ////////////////////////

        //chat Desktop Notification state for HostAttendee Chat in a webinar
        function determineStateOfChatNotifications(state) {
            disabledChatNotifications = state;
        }

        function onNotificationServiceShow(event, message, type, title) {
            service.show(message, type, title);
        }

        //sets the user preference on whether to show or hide desktop notifications in a meeting
        function determineIfShowingDesktopNotifications(state) {
            userShowingDesktopNotifications = state;
        }

        function canShowDesktopNotification() {
            return (
                (helperService.isBrowserInFocus() === false || inCompactMode) &&
                helperService.isMobile() === false &&
                helperService.hasNotificationAPIPermission() === true &&
                helperService.isVideoRoomApplication() === false &&
                userShowingDesktopNotifications
            );
        }

        function tryShowDesktopNotification(message, type, title) {
            if (service.canShowDesktopNotification()) {
                desktopNotificationService.show(message, type, title);
            }
        }

        function show(message, type, title) {
            if (meetingService.isWebinarAttendee() && !meetingService.getIsOnAir()) {
                // Don't show a notification
                return;
            }

            if (type === 'chat' && disabledChatNotifications && !inCompactMode) {
                return;
            }

            if (service.canShowDesktopNotification()) {
                desktopNotificationService.show(message, type, title);
            } else {
                growlService.show(message, type, title);
            }
        }

        function onCompactModeReceived(e, data) {
            inCompactMode = data;
        }

        function onServerCommandFailed(e, data) {
            logger.log('Server command failed:', data.command, '- Error response:', data.response);
            analyticsWrapperService.eventTrack('Meeting - Notification Service - Server Command Failed');

            var title = localizationService.translate('COMMON.OOPS_TEXT');
            var message = '';

            switch (data.command) {
                case 'setDefaultLayout':
                    break;
                case 'getPlayStatus':
                    if (data.parentCommand === 'onPlayVideo' || data.parentCommand === 'onLoadSlides') {
                        message = 'There was some trouble sharing this content. Please try again.';
                    }

                    break;
                case 'setScreenShareLayout':
                    if (data.parentCommand === 'onScreenShareStarted') {
                        message = 'There was some trouble sharing your screen. Please try again.';
                        $rootScope.$broadcast('stop-screenshare');
                    }

                    if (data.parentCommand === 'restoreContent') {
                        message = localizationService.translate('ATTENDEE_LIST.DIALOG.ERROR_SHOWING_WEBCAM');
                    }

                    break;
                case 'loadSlides':
                    message = 'There was some trouble loading your slides. Please try again.';
                    $rootScope.$broadcast('cancel-content-initiation');
                    break;
                case 'stopSlides':
                    message = 'There was some trouble closing your slides. Please try again.';

                    //If user was trying to override content (stop current content and play new content),
                    //we no longer want to continue with that action if there is an issue stopping the current content
                    $rootScope.$broadcast('clear-content-override');
                    break;
                case 'goToSlide':
                    message = 'There was some trouble loading that slide. Please try again.';
                    break;
                case 'setFileShareLayout':
                    if (data.parentCommand === 'onPlayVideo') {
                        message = 'There was some trouble loading your video. Please try again.';
                        $rootScope.$broadcast('cancel-content-initiation');
                    }

                    if (data.parentCommand === 'onLoadSlides') {
                        message = 'There was some trouble loading your slides. Please try again.';
                        $rootScope.$broadcast('cancel-content-initiation');
                    }

                    break;
                case 'playVideo':
                    message = 'There was some trouble loading your video. Please try again.';
                    $rootScope.$broadcast('cancel-content-initiation');
                    break;
                case 'pauseVideo':
                    message = 'There was some trouble toggling your video playback. Please try again.';
                    $rootScope.$broadcast('enable-pause-button');
                    break;
                case 'stopVideo':
                    message = 'There was some trouble ending your video. Please try again.';

                    //If user was trying to override content (stop current content and play new content),
                    //we no longer want to continue with that action if there is an issue stopping the current content
                    $rootScope.$broadcast('clear-content-override');
                    break;
                case 'seekVideo':
                    message = 'There was some trouble with video seeking. Please try again.';
                    break;
                case 'mute':
                    //Don't want to spam user if multiple mute commands fail...
                    //So we skip if mute command fails during mute-all
                    if (data.parentCommand !== 'onAudioMuteAll') {
                        message = localizationService.translate('ATTENDEE_LIST.DIALOG.ERROR_MUTE_ATTENDEE');
                    }

                    break;
                case 'unmute':
                    message = localizationService.translate('ATTENDEE_LIST.DIALOG.ERROR_UNMUTE_ATTENDEE');
                    break;
                case 'vmute':
                    message = localizationService.translate('ATTENDEE_LIST.DIALOG.ERROR_HIDE_WEBCAM');
                    break;
                case 'unvmute':
                    message = localizationService.translate('ATTENDEE_LIST.DIALOG.ERROR_SHARE_WEBCAM');
                    break;
                case 'startRecording':
                    message = localizationService.translate('ATTENDEE_LIST.DIALOG.SOME_TROUBLE_STARTING_RECORD');
                    $rootScope.$broadcast('end-wait-for-recording-response');
                    break;
                case 'stopRecording':
                    message = localizationService.translate('ATTENDEE_LIST.DIALOG.SOME_TROUBLE_STOPING_RECORD');
                    $rootScope.$broadcast('end-wait-for-recording-response');
                    break;
                case 'removeRecordings':
                    message = localizationService.translate('ATTENDEE_LIST.DIALOG.SOME_TROUBLE_STARTING_RECORD');
                    $rootScope.$broadcast('end-wait-for-recording-response');
                    break;
                case 'kick':
                    message = localizationService.translate('ATTENDEE_LIST.DIALOG.ERROR_KICK_ATTENDEE');
                    break;
                case 'virtualAssistantStart':
                    showVirtualAssistantFailedMessage();
                    return;
                default:
                    break;
            }

            if (title && message) {
                showSweetAlert(title, message);
            }
        }

        function showSweetAlert(title, message) {
            if (helperService.getIsRedesign() === true) {
                var closeButtonHtml =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                $window.swal({
                    title: closeButtonHtml + title,
                    text: message,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                    allowOutsideClick: true,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
                });
            } else {
                //TODO: REMOVE POST-REDESIGN
                $window.swal({
                    title: title,
                    text: message,
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                    allowOutsideClick: true
                });
            }
        }

        function showVirtualAssistantFailedMessage() {
            analyticsWrapperService.eventTrack('Meeting - Virtual Assistant - Start Failed');

            var text = localizationService.translate('ATTENDEE_LIST.DIALOG.VIRTUAL_ASSISTANT_MEETING_CONNECT_ERROR');

            if (helperService.getIsRedesign() === true) {
                var closeButtonHtmlVirtualAssistantFailed =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                $window.swal(
                    {
                        title:
                            closeButtonHtmlVirtualAssistantFailed +
                            localizationService.translate('ATTENDEE_LIST.DIALOG.VIRTUAL_ASSISTANT_ERROR'),
                        text: text,
                        imageUrl: 'img/redesign/modal/virtual-assistant-huge.svg',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                        allowOutsideClick: true,
                        html: true
                    },
                    function (confirmed) {}
                );
            } else {
                //TODO: REMOVE POST-REDESIGN
                $window.swal(
                    {
                        title: 'Virtual Assistant Error',
                        text: text,
                        imageUrl: 'img/icons/sad-robot.png',
                        imageSize: '100x100',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: 'Ok',
                        allowOutsideClick: true,
                        html: true
                    },
                    function (confirmed) {}
                );
            }
        }

        //This is to broadcast hide/show events when sweet alerts
        //are opened/closed... allows promptService to keep track
        function overrideSwal() {
            logger.debug('Overriding swal open/close functions');
            try {
                $window.swal = (function () {
                    const cachedFunc = $window.swal;
                    return function () {
                        const preserveModal = arguments[0] && arguments[0].preserveModal;
                        if (swalIsOpen && preserveModal) {
                            swalQueue.push([...arguments]);
                            return;
                        }
                        $rootScope.$broadcast('show-swal');
                        const result = cachedFunc.apply(this, arguments);
                        swalIsOpen = true;
                        return result;
                    };
                })();

                //When sweet alerts are closed via 'cancel' buttons,
                //the internal code calls this function
                $window.sweetAlert.close = (function () {
                    const cachedFunc = $window.sweetAlert.close;
                    return function () {
                        $rootScope.$broadcast('hide-swal');
                        const result = cachedFunc.apply(this, arguments);
                        swalIsOpen = false;
                        if (swalQueue.length > 0) {
                            // timeout is necessary for swal to reapply custom classes
                            $timeout(() => $window.swal(...swalQueue.shift()), 500);
                        }
                        return result;
                    };
                })();

                //Overriding the swal function clears the swal.close function,
                //so we add it back here
                $window.swal.close = $window.sweetAlert.close;
            } catch (e) {
                logger.error('overrideSwal', 'Unable to override swal functions', e);
            }
        }
    }
]);
